var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBusIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_689_7964)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#155ABF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62973 21.8625C9.08373 21.425 8.71973 20.725 8.71973 19.9375V11.1875C8.71973 8.125 11.9957 7.6875 15.9997 7.6875C20.0037 7.6875 23.2797 8.125 23.2797 11.1875V19.9375C23.2797 20.725 22.9157 21.425 22.3697 21.8625V23.4375C22.3697 23.9625 22.0057 24.3125 21.4597 24.3125H20.5497C20.0037 24.3125 19.6397 23.9625 19.6397 23.4375V22.5625H12.3597V23.4375C12.3597 23.9625 11.9957 24.3125 11.4497 24.3125H10.5397C9.99373 24.3125 9.62973 23.9625 9.62973 23.4375V21.8625ZM10.5397 19.5C10.5397 20.2 11.1767 20.8125 11.9047 20.8125C12.6327 20.8125 13.2697 20.2 13.2697 19.5C13.2697 18.8 12.6327 18.1875 11.9047 18.1875C11.1767 18.1875 10.5397 18.8 10.5397 19.5ZM20.0947 20.8125C19.3667 20.8125 18.7297 20.2 18.7297 19.5C18.7297 18.8 19.3667 18.1875 20.0947 18.1875C20.8227 18.1875 21.4597 18.8 21.4597 19.5C21.4597 20.2 20.8227 20.8125 20.0947 20.8125ZM10.5397 15.5625H21.4597V11.1875H10.5397V15.5625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_689_7964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBusIconBlue);
export default __webpack_public_path__ + "static/media/ic_bus_icon_blue.8b2555b3855b0e0989e06b5f51351854.svg";
export { ForwardRef as ReactComponent };